import { memo } from 'react'

import { twMerge } from 'tailwind-merge'

import { IconCross } from '~/components'

type CloseMapButtonProps = {
  onClose: () => void
  className?: string
}

const CloseMapButtonComponent = ({
  onClose,
  className,
}: CloseMapButtonProps) => {
  return (
    <button
      className={twMerge(
        'inline-flex cursor-pointer items-center justify-center gap-1 rounded-[55px] bg-black bg-opacity-70 px-4 py-2 text-body-s-bold text-white shadow-md',
        className,
      )}
      onClick={onClose}
    >
      地図を閉じる
      <IconCross className="text-white" />
    </button>
  )
}

export const CloseMapButton = memo(CloseMapButtonComponent)
